
(function($) {

    const TableExporter = function(element) {
        this.element  = $(element);
        this.table = this.element.data('bootstrap.table');

        // Abort if table is empty
        if (this.table.options.totalRows == 0) {
            Notifications.error("Aucune donnée à exporter");
            return;
        }

        // Show modal
        this.loadingModal = new $.fn.ajaxModal.Constructor({
            size: 'small',
            modalClass: 'modal-loader',
            content: '<div class="modal-content">' +
            '<div class="modal-body">' +
                '<div class="modal-spinner">' +
                    '<i class="zmdi zmdi-hc-spin zmdi-spinner"></i>' +
                '</div>' +
                'Chargement en cours, merci de patienter' +
            '</div>' +
            '</div>'
        });
        this.loadingModal.show();

        // Query data
        const data = this.table.options.queryParams({
            pageSize: this.table.options.totalRows,
            pageNumber: 1,
            searchText: this.table.searchText,
            sortName: this.table.options.sortName,
            sortOrder: this.table.options.sortOrder
        });

        // Load data
        $.ajax({
            url: this.table.options.url,
            data: data,
            cache: this.table.options.cache,
            contentType: this.table.options.contentType,
            dataType: this.table.options.dataType,
            complete: () => {
                this.loadingModal.hide();
            },
            success: response => {
                this.finishExport(response.data);
            }
        });
    };

    $.extend(TableExporter.prototype, {
        finishExport: function(data) {
            const filename = this.table.options.exportFilename;
            const workbook = XLSX.utils.book_new();
            workbook.Props = {
                Title: filename,
                Subject: filename,
                Author: this.table.options.exportAuthor,
                CreatedDate: new Date()
            };

            // Get columns to export
            const exportColumns = this.table.options.exportColumns;
            const columns = this.table.columns.filter(function(column) {
                return -1 !== exportColumns.indexOf(column.field);
            });

            // WS headers
            const headers = [];

            $.each(columns, (index, column) => {
                headers.push(this.decodeHtmlEntities(column.title.trim()));
            });

            const ws_data = [headers];

            // WS data
            $.each(data, function(i, row) {
                var row_data = [];

                $.each(columns, function (index, column) {
                    var value = column.exporter(row[column.field], row, index) || '';
                    row_data.push(value);
                });

                ws_data.push(row_data);
            });

            // Make Worksheet
            workbook.SheetNames.push(filename);
            workbook.Sheets[filename] = XLSX.utils.aoa_to_sheet(ws_data);

            const out = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'binary'
            });

            saveAs(new Blob([ this.s2ab(out) ], {
                type: 'application/octet-stream'
            }), filename + '_' + moment().format('YYYYMMDD_HHmmss') + '.xlsx');
        },

        s2ab: function(s) {
            const buffer = new ArrayBuffer(s.length);
            const view = new Uint8Array(buffer);
            for (let i = 0 ; i < s.length ; ++i) {
                view[i] = s.charCodeAt(i) & 0xFF;
            }

            return buffer;
        },

        decodeHtmlEntities: function(s) {
            var textarea = document.createElement('textarea');
            textarea.innerHTML = s;

            return textarea.value;
        }
    });

    $(document).on('click', '[data-table-export]', event => {
        event.preventDefault();

        const target = $(event.currentTarget);
        const element  = '#' + target.attr('data-table-export');

        const exporter = new TableExporter(element);
    });

})(jQuery);


// WEBPACK FOOTER //
// ./js/table-export.js